import FormHelpers from "../../../../helpers/FormHelpers";

const ERROR_MESSAGES = {
  requiredField: (fieldName) => `Error in ${fieldName} field. Select/Enter a valid value then proceed.`,
};

const isNetZeroQuantity = (data) => {

  const totalBatches = data?.filter(item => item?.batch_id);

  const zeroFilledBatches = totalBatches?.filter(item => !item?.batch_wise_quantity || Number(item?.batch_wise_quantity) == 0);

  if (totalBatches?.length == zeroFilledBatches?.length) {
    return true;
  }
  return false;
}

const validateDocLevelError = ({
grnDate,
deliveryDate,
cfGoodReceivingNotesDoc,
grnNumber,
}) => {

  const errors = [];

  if(!grnNumber) {
    errors.push({
      name: 'GRN Number',
      value: grnNumber,
      message: ERROR_MESSAGES.requiredField('GRN Number'),
    })
  }

  // doc mandatory fields
  errors.push({
    name: 'GRN Date',
    value: grnDate,
    message: ERROR_MESSAGES.requiredField('GRN Date'),
  })
  errors.push({
    name: 'DC Date',
    value: deliveryDate,
    message: ERROR_MESSAGES.requiredField('DC Date'),
  })

  // mandatory custom fields
  if (cfGoodReceivingNotesDoc) {
    cfGoodReceivingNotesDoc?.forEach((field) => {
      if (field?.isRequired && field?.isActive) {
        errors.push({
          name: field?.fieldName,
          value: field?.fieldValue,
          message: ERROR_MESSAGES.requiredField(field?.fieldName),
        });
      }
    });
  }

  return errors;

};

const validateLineLevelError = ({
  grnTableData,
}) => {

  const errors = [];

  if (grnTableData) {

    // net zero quantity check
    if (isNetZeroQuantity(grnTableData)) {
      errors.push({
        name: 'No Received Quantity',
        value: 0,
        message: 'Error in RECEIVING QTY. Please enter a value in at least one line.',
      })
    }

    // excess value check
    grnTableData?.forEach((item) => {
      if (item?.batch_id && (item?.batch_wise_quantity > item?.quantity || Number(item?.batch_wise_quantity) < 0)) {
        errors.push({
          name: `RECEIVING QTY of batch ${item?.custom_batch_number || item?.batch_number}`,
          value: 0,
          message: ERROR_MESSAGES.requiredField(`RECEIVING QTY of Batch Number ${item?.custom_batch_number || item?.batch_number}`),
        })
      }
    })
  }

  return errors;
};

const GrnErrors = (params) => {
  const docLevelErrors = validateDocLevelError(params);
  const lineLevelErrors = validateLineLevelError(params);

  return FormHelpers.errorChecker({ docLevelErrors, lineLevelErrors });
};

export default GrnErrors;